module.exports = __webpack_public_path__ + "media/images/landing-page-d893feaf05d54aa04b96a6a49a73009a.png";